// extracted by mini-css-extract-plugin
export default {"kTextbox":"AgriculturalUseCategoriesOfLandTable_kTextbox__gMtpU","GreyedOut":"AgriculturalUseCategoriesOfLandTable_GreyedOut__zRLW-"};